<template>
  <div class="rangeslide-filter standalone-filter">  
      <v-row class="mb-0 pb-0 mt-0"
      justify="start"
      align="center"
    >      
        <v-col cols="auto" class="mb-0 pa-0 pl-2">
          <v-checkbox
          class="pb-0 pt-0 mt-0 mb-0"
          v-model="active"
          :label="options.title"
          hide-details
          @change="updateFilter"
        >
        </v-checkbox>
        </v-col>        
        
        <v-col justify="end" class="mb-0 pa-0">
        <filter-title 
          :show-title="false"
          :title="options.title"
          :show-settings-button="false"
          :show-reset-button="false"
          @toggle-description="showDescription = !showDescription"
        ></filter-title>
        </v-col>
      </v-row>
      <v-row>
        <filter-description
          :title="options.title"
          :show="showDescription"
          :description="options.description"
        />
      </v-row>
  </div>
</template>
<script>
import FilterTitle from "./FilterTitle";
import FilterDescription from "./FilterDescription";
import { getQueryStringForCheckbox } from "./utils.js"
import { mapActions } from "vuex";
export default {
  name: "FilterCheckBox",
  data () {
    return {
      toggleSettings: {
        labels: { checked: "Ja", unchecked: "Nei" }
      },
      active: false,
      showDescription: false
    };
  },
  components: {
    FilterTitle, FilterDescription
  },
  props: {
    options: Object,
    parameter: String
  },
  methods: {
    ...mapActions(["setFilterValue"]),
    updateFilter: function (value) {
      
      this.active = value;
      
      let filterQueryString = getQueryStringForCheckbox(
        this.active,
        {
          filterFieldName: this.parameter,
          ...this.options
        }
      );
      this.emitFilterChanged(this.parameter, filterQueryString);
    },
    resetFilter: function () {
      this.active = false;
      let filterQueryString = getQueryStringForCheckbox(
        false,
        {
          filterFieldName: this.parameter,
          ...this.options
        }
      );
      this.emitFilterChanged(this.parameter, filterQueryString);
    },
    emitFilterChanged (filterFieldName, filterQueryString) {
      this.setFilterValue({
        filterFieldName: filterFieldName,
        filterQueryString: filterQueryString
      });
    }
  },
  created: function () {
    this.$eventHub.$on("reset-all-filters", this.resetFilter);
  },
  mounted: function() {
    this.active = this.options.value;
  }
};
</script>

<style>
.checkbox-filter {  
  margin-bottom: 10px;
  margin-top: 10px;
  margin-right: 10px;
}
</style>

